import React from 'react';
import { useTranslation } from 'react-i18next';
import { CHANGE_PASSWORD_TRANSLATION_NAMESPACE, STATUS_IDLE } from 'consts';
import { EnelXGuiAtoms } from 'gui';
// import { t } from 'i18n_new';
import { ContainerChangePassword, TitelText } from 'pages/changePassword/styles';
import PropTypes from 'prop-types';

const { MigrationButton } = EnelXGuiAtoms;

function ErrorPassword({ handleUtility, resetToInitial }) {
  const { t } = useTranslation(CHANGE_PASSWORD_TRANSLATION_NAMESPACE);
  return (
    <ContainerChangePassword>
      <div className="error-wrapper">
        <TitelText Titel="titel">{t('anErrorHasOccurred')}</TitelText>
        <div className="closeIcon icon-close-5" />
        <div className="error-subtext">
          <TitelText>{t('thePasswordNotUpdated')}</TitelText>
        </div>
        <div className="ok-btn">
          <MigrationButton
            btnText={t('ok')}
            btnType="primary"
            onClick={() => {
              resetToInitial();
              handleUtility('pswStatus', STATUS_IDLE);
            }}
          />
        </div>
      </div>
    </ContainerChangePassword>
  );
}

export default ErrorPassword;

ErrorPassword.propTypes = {
  handleUtility: PropTypes.func.isRequired,
  resetToInitial: PropTypes.func.isRequired,
};
